import Vue from 'vue';
import Router from 'vue-router';
import { sync } from 'vuex-router-sync';
import authRoutes from '@/core/shared/auth/auth-routes';
// we are using an event bus for routing inside vuex-actions because we need the store instance for routing-logic (permissions, etc...)
// but we have to avoid circular references
import store from '@/core/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    ...authRoutes,
    {
      name: 'home',
      path: '/home',
      component: () => import('@/Home'),
    },
    {
      name: 'no-location',
      path: '/no-location',
      component: () => import('@/location/NoLocation'),
    },
    {
      path: '/:locationId',
      props: true,
      component: () => import('@/location/LocationRoute'),
      name: 'location',
      redirect: to => {
        const { params } = to;
        return { name: 'overview', params };
      },
      children: [
        {
          name: 'overview',
          path: 'overview',
          component: () => import('@/location/overview/OverviewRoute'),
          props: true,
          meta: {
            noScroll: true,
          },
          children: [
            {
              name: 'walkin',
              path: 'walkin',
              component: () => import('@/location/booking/WalkinRoute'),
              props: true,
              meta: {
                noScroll: true,
              },
            },
            {
              name: 'booking-detail',
              path: 'station/:stationId/booking/:bookingId',
              component: () => import('@/location/overview/calendar/booking-detail/BookingDetailRoute'),
              props: true,
              meta: {
                noScroll: true,
              },
            },
            {
              name: 'closing-detail',
              path: 'station/:stationId/closing/:closingId',
              component: () => import('@/location/overview/calendar/closing-detail/ClosingDetailRoute'),
              props: true,
              meta: {
                noScroll: true,
              },
            },
            {
              name: 'paid-extension',
              path: 'station/:stationId/booking/:bookingId/extension/:bookingStationTimeIndex',
              component: () => import('@/location/overview/calendar/paid-extension/PaidExtensionRoute'),
              props: true,
              meta: {
                keepOpen: true,
                noScroll: true,
              },
            },
          ],
        },

        {
          name: 'remote-launch',
          path: 'remote-launch',
          component: () => import('@/location/remote-launch/RemoteLaunchRoute.vue'),
          props: true,
          meta: {
            keepOpen: true,
          },
        },

        {
          name: 'booking',
          path: 'booking/:bookingId',
          props: true,
          component: () => import('@/location/booking/new-and-edit/BookingRoute'),
        },

        {
          name: 'edit-booking-after-start',
          path: 'booking/:bookingId/edit-post-starting',
          props: true,
          component: () => import('@/location/booking/new-and-edit/EditBookingAfterStartRoute'),
        },

        {
          name: 'multiple-stations-settings',
          path: 'station/multipleStations/settings',
          component: () => import('@/location/station-settings/MultipleStationsSettingsRoute'),
          props: true,
          beforeEnter: (to, from, next) => {
            if (to.params.stationsId) {
              next();
            } else {
              return false;
            }
          },
        },

        {
          name: 'station-settings',
          path: 'station/:stationId/settings',
          component: () => import('@/location/station-settings/StationSettingsRoute'),
          props: true,
        },

        // This is used soley for mobile.
        {
          name: 'mobile-station-calendar',
          path: 'station/:stationId/calendar',
          props: true,
          component: () => import('@/location/overview/mobile/MobileStationDetailRoute'),
        },
        {
          name: 'mobile-booking-detail',
          path: 'station/:stationId/booking/:bookingId',
          props: true,
          component: () => import('@/location/overview/mobile/MobileBookingDetailRoute'),
        },
      ],
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (!to.meta.noScroll) {
      return { x: 0, y: 0 };
    }
  },
});

sync(store, router);

export default router;

export function useRouter () {
  return router;
}
